import { useRequest } from '@hooks';

import api from '../../api';

const CalculateQuotation = () => useRequest(
  (propertyId, bricksQuantity) => api.get(
    `/properties/${propertyId}/quotations/calculate?bricksQuantity=${bricksQuantity}`
  )
);

const FetchReservation = () => useRequest(() => api.get('/traders/me/bricks/reserved'));

const ReleaseReservedBricks = () => useRequest(
  () => api.post('/properties/bricks/releaseReserved')
);

const ReserveBricks = () => useRequest((propertyId, payload) => api.post(
  `/properties/${propertyId}/bricks/reserve`,
  payload
));

export {
  CalculateQuotation,
  FetchReservation,
  ReleaseReservedBricks,
  ReserveBricks
};
